export interface UtilityItem {
  icon: string;
  headline: string;
  subtitle: string;
  parentOption: string;
  value: string;
}

export interface AvailableOption {
  label: string;
  value: string;
}

export const utilities = {
  // translate: "Translate",
  // animate: 'Animate',
  generate: "Generate",
  dynamicCreative: "Generate Similar",
  AIEditor: "Edit With AI",
  resize: "Adapt",
  custom: "Custom",
};

export const customUtilities = {
  icon: "Icon",
};

// Output type for Generate / Generate Similar: an ad creative or a social media post.
export const outputTypes = {
  ad: "ad",
  socialPost: "social_post",
};

export const outputTypesForDisplay = [
  { value: outputTypes.ad, label: "Ad", icon: "mdi-bullhorn-variant-outline" },
  { value: outputTypes.socialPost, label: "Social Media Post", icon: "mdi-share-variant-outline" },
];

export const availableOptions: Record<string, AvailableOption> = {
  allUtilities: {
    label: "labels.allUtilities",
    value: "AllUtilities",
  },
  create: {
    label: "labels.create",
    value: "Create",
  },
  convert: {
    label: "labels.convert",
    value: "Convert",
  },
  custom: {
    label: "labels.custom",
    value: "Custom",
  },
};

export const utilitiesForDisplay: UtilityItem[] = [
  {
    icon: "mdi-creation",
    headline: "labels.generateHeadline",
    subtitle: "labels.defaultSubheadlineForAIUtilities",
    parentOption: availableOptions.create.value,
    value: utilities.generate,
  },
  {
    icon: "mdi-animation-outline",
    headline: "labels.generateSimilarHeadline",
    subtitle: "labels.defaultSubheadlineForAIUtilities",
    parentOption: availableOptions.convert.value,
    value: utilities.dynamicCreative,
  },
  {
    icon: "mdi-robot",
    headline: "labels.editWithAIHeadline",
    subtitle: "labels.defaultSubheadlineForAIUtilities",
    parentOption: availableOptions.convert.value,
    value: utilities.AIEditor,
  },
  {
    icon: "mdi-resize",
    headline: "labels.resizeHeadline",
    subtitle: "labels.defaultSubheadlineForAIUtilities",
    parentOption: availableOptions.convert.value,
    value: utilities.resize,
  },
  {
    icon: "mdi-rectangle-outline",
    headline: "labels.iconHeadline",
    subtitle: "labels.defaultSubheadlineForAIUtilities",
    parentOption: availableOptions.custom.value,
    value: customUtilities.icon,
  },
];

export const labels = {
  promotional: "Promotional",
  seasonal: "Seasonal",
  launch: "Launch",
  highlight: "Highlight",
  budget: "Budget",
  luxury: "Luxury",
};

export const styles = [
  {
    id: 1,
    name: "Minimal",
  },
  {
    id: 2,
    name: "Modern",
  },
  {
    id: 3,
    name: "Animated",
  },
  {
    id: 4,
    name: "Realistic",
  },
  {
    id: 5,
    name: "Luxurious",
  },
  {
    id: 6,
    name: "Vintage",
  },
  {
    id: 7,
    name: "Futuristic",
  },
  {
    id: 8,
    name: "Bold",
  },
];

export const tones = [
  {
    id: 1,
    name: "Professional",
  },
  {
    id: 2,
    name: "Casual",
  },
  {
    id: 3,
    name: "Playful",
  },
  {
    id: 4,
    name: "Neutral",
  },
  {
    id: 5,
    name: "Edgy",
  },
];

export const layouts = [
  {
    id: 1,
    name: "Hero",
  },
  {
    id: 2,
    name: "Balanced",
  },
  {
    id: 3,
    name: "Text-Focused",
  },
  {
    id: 4,
    name: "None (Auto)",
  },
];

export const resolutions = [
  { id: 1, name: "1K" },
  { id: 2, name: "2K" },
  { id: 3, name: "4K" },
];

export const ASPECT_RATIOS = [
  { id: "match_input_image", name: "Match Input Image" },
  { id: "1:1", name: "1:1 (Square)" },
  { id: "2:3", name: "2:3 (Portrait)" },
  { id: "3:2", name: "3:2 (Landscape)" },
  { id: "3:4", name: "3:4 (Portrait)" },
  { id: "4:3", name: "4:3 (Landscape)" },
  { id: "4:5", name: "4:5 (Instagram Portrait)" },
  { id: "5:4", name: "5:4 (Standard)" },
  { id: "9:16", name: "9:16 (Vertical / Story)" },
  { id: "16:9", name: "16:9 (Horizontal / Video)" },
  { id: "21:9", name: "21:9 (Cinematic)" },
];

export const ASPECT_RATIOS_FOR_GENERATE_SIMILAR = [
  { id: "1:1", name: "1:1 (Square)" },
  { id: "2:3", name: "2:3 (Portrait)" },
  { id: "3:2", name: "3:2 (Landscape)" },
  { id: "3:4", name: "3:4 (Portrait)" },
  { id: "4:3", name: "4:3 (Landscape)" },
  { id: "4:5", name: "4:5 (Instagram Portrait)" },
  { id: "5:4", name: "5:4 (Standard)" },
  { id: "9:16", name: "9:16 (Vertical / Story)" },
  { id: "16:9", name: "16:9 (Horizontal / Video)" },
  { id: "21:9", name: "21:9 (Cinematic)" },
];

export const LANGUAGES = [
  { id: "en", name: "English" },
  { id: "fr", name: "French" },
  { id: "pt", name: "Portuguese" },
];

export const THEMES = [
  { id: 1, name: "FIFA World Cup 2026" },
  { id: 2, name: "Festive Celebration" },
  { id: 3, name: "Celebrity Ambassador" },
  { id: 4, name: "Product Launch" },
  { id: 5, name: "Premium Lifestyle" },
  { id: 6, name: "Urban Explorer" },
  { id: 7, name: "Family Adventure" },
  { id: 8, name: "French Canadian Lifestyle" },
];
